module.exports = __webpack_public_path__ + "static/media/Basal_5041.9731dc70.jpg";